import React from "react";
import {
    faHome,
    faCircleQuestion,
    faBuilding,
    faMoneyBillTransfer,
    faList, 
    faBuildingFlag,
    faFileImport
} from "@fortawesome/free-solid-svg-icons";
import ModuleFactory from "../../../commonComponents/moduleFactory";
import FilterProvider from "../../../commonComponents/filterProvider";

export default function PaymentManagement() {
    const sidebarItems = [
        {icon: faHome, text: "PAYMENT MANAGEMENT", to: '/payment-management/'},
        // {icon: faBuilding, text: "LOTS", to: 'lots'},
        {icon: faBuildingFlag, text: "PROJECTS", to: 'projects'},
        {icon: faList, text: "TRANSACTIONS", to: 'transactions'},
        {icon: faFileImport, text: "IMPORT", to: 'import'},
        {icon: faCircleQuestion, text: "NEED HELP?", to: 'help'}
    ];

    const subItems = [
        // 'lots',
        'projects',
        'transactions',
        'import'
    ];
    const pathsWithNoSidebar = [];

    return <FilterProvider>
        <ModuleFactory sidebarItems={sidebarItems} subItems={subItems} pathsWithNoSidebar={pathsWithNoSidebar} />
    </FilterProvider>;
}
